import styled from "styled-components";
import { smallTablet } from "./MediaQueries";

export const SmallTablet = styled.div`
  display: block;
  @media (${smallTablet}) {
    display: none;
  }
`

const BiggerThanSmallTablet = styled.div`
  display: none;
  @media (${smallTablet}) {
    display: block;
  }
`
